<div class="relative lg:static w-full flex flex-col-reverse lg:block" #selectContainer>

    <!-- BOTON PRINCIPAL -->
    <div class="relative">

      <button
          type="button"
          role="button"
          [class]="cssClass"
          [class.opacity-80]="disabled"
          [disabled]="disabled"
          (click)="toggleDropdown()"
          (keydown)="onKeydown($event)"
          aria-haspopup="listbox"
       >

        <div class="flex items-center justify-between">

          <!-- TEXTO DEL BOTON -->
          <span class="block truncate">
              {{ inputLabel }}
          </span>

          <!-- FLECHA -->
             <svg class="w-5 h-5 ml-2 transition" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="{'rotate-180': (openOptions && !isMobile()) || (!openOptions && isMobile())}">
               <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>

        </div>

      </button>

      <!-- CARET (solo desktop) -->
      @if (openOptions) {
        <div class="hidden lg:block absolute left-1/2 top-full mt-4 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rotate-45 bg-white z-20"></div>
      }

    </div>

    <!-- DROPDOWN -->
    @if (openOptions) {

      <!-- CONTAINER -->
      <div
          class="absolute z-10 w-full flex flex-col-reverse mb-9 bg-white rounded-2xl shadow-md max-h-60 overflow-hidden lg:block lg:w-auto lg:left-0 lg:right-0 lg:top-full lg:mt-4 lg:mb-0"
          tabindex="-1"
          role="listbox"
        >

          <!-- BUSCADOR -->
          <div class="sticky top-0 bg-white p-3 lg:p-4">

            <input
              #searchInput
              type="text"
              class="w-full px-4 py-2.5 text-sm rounded-xl border border-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-black/20"
              [placeholder]="translation.getText('search_tool', 'placeholder_advanced')"
              (input)="onSearch()"
              [(ngModel)]="searchText"
              (click)="$event.stopPropagation()"
            />

          </div>

          <!-- RESULTADOS -->
          @if (filteredOptions.length > 0) {

            <ul class="options-list px-2 pb-2 max-h-48 overflow-y-auto">

              @for (option of filteredOptions; track option.value) {

                <li
                  class="px-3 py-2.5 cursor-pointer rounded-lg text-sm font-semibold text-gray-800 hover:bg-black/5"
                  tabindex="0"
                  role="option"
                  aria-selected="false"
                  [class]="{'bg-black/5': option.value === value?.value || highlightedIndex === filteredOptions.indexOf(option)}"
                  (click)="onSelect(option)"
                  (keypress.enter)="onSelect(option)"
                >
                  {{ option.label }}
                </li>

              }

            </ul>

          }

          @else {

            <div class="px-4 py-3 text-gray-500 text-sm">
              {{ translation.getText('search_tool', 'no_results', 'No results found') }}
            </div>

          }

      </div>

    }

</div>
